module.exports = __webpack_public_path__ + "images/aristo/icon_sprite.png";